import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  values: [],
  questions: [],
  selected: null,
  reloading: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
